export const SET_WEBSITE_STYLES = 'SET_WEBSITE_STYLES'
export const UPDATE_WEBSITE_STYLES_TYPOGRAPHY_PARAGRAPH =
  'UPDATE_WEBSITE_STYLES_TYPOGRAPHY_PARAGRAPH'
export const UPDATE_WEBSITE_STYLES_TYPOGRAPHY_HEADING =
  'UPDATE_WEBSITE_STYLES_TYPOGRAPHY_HEADING'
export const UPDATE_WEBSITE_STYLES_PRIMARY_BUTTONS_TYPOGRAPHY =
  'UPDATE_WEBSITE_STYLES_PRIMARY_BUTTONS_TYPOGRAPHY'
export const SET_WEBSITE_THEMES_LIST = 'SET_WEBSITE_THEMES_LIST'
export const SET_WEBSITE_THEME = 'SET_WEBSITE_THEME'
export const SET_WEBSITE_DRAFT_THEME = 'SET_WEBSITE_DRAFT_THEME'
export const SET_WEBSITE_SETTINGS = 'SET_WEBSITE_SETTINGS'
